<template>
  <div class="role-manage">
    <el-button icon="el-icon-plus" size="small" @click="handleClick">新建角色</el-button>
    <el-table :data="list" class="table">
      <el-table-column label="角色" prop="name" width="150">
      </el-table-column>
      <el-table-column label="权限">
        <template slot-scope="scope" v-if="scope.row.permissions">
          <el-checkbox-group :value="scope.row.permissions">
            <span v-for="item in permissions" style="display:inline-block;margin-right:20px">
              <el-checkbox :label="item.name" :key="item.name">{{item.title}}</el-checkbox>
            </span>
          </el-checkbox-group>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editItem(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="deleteItem(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pager"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 10, 15, 20]"
      :page-size="per_page"
      layout="total, sizes, prev, pager, next"
      :total="total">
    </el-pagination>
    <el-dialog :title="!edit?'创建':'编辑'" :visible.sync="dialogVisible" width="800px">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="角色名称" prop="name">
          <el-input v-model="form.name" placeholder="角色名称" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="角色权限" prop="permissions">
          <el-checkbox-group class="check-box" v-model="form.permissions">
            <p v-for="item in permissions">
              <el-checkbox :label="item.name" :key="item.name">{{item.title}}</el-checkbox>
            </p>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-show="!edit" type="primary" @click="handleSubmit">确 定</el-button>
        <el-button v-show="edit" type="primary" @click="handleSubmit2">保存更改</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  name: 'RoleManage',
  data () {
    return {
      permissions: this.$store.getters.getMainRoutes,
      edit: false,
      list: [],
      page: 1,
      per_page: 10,
      total: 0,
      current: {},
      dialogVisible: false,
      form: {
        name: '',
        permissions: []
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    editItem(row) {
      this.current = JSON.parse(JSON.stringify(row))
      this.form = {
        name: this.current.name,
        permissions: this.current.permissions || []
      }
      this.edit = true
      this.dialogVisible = true
    },
    deleteItem(row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/roles/' + row.uuid,
          method: 'delete'
        }).then(res => {
          this.$message.success('删除成功!')
          this.getList()
        })
      }).catch()
    },
    handleClick() {
      this.edit = false
      this.dialogVisible = true
      this.form = {
        name: '',
        permissions: []
      }
    },
    handleSizeChange (e) {
      this.per_page = e
      this.page = 1
      this.getList()
    },
    handleCurrentChange (e) {
      this.page = e
      this.getList()
    },
    handleSubmit() {
      request({
        url: '/roles',
        method: 'post',
        data: this.form
      }).then(res => {
        this.$message.success('创建成功')
        this.getList()
        this.dialogVisible = false
      })
    },
    handleSubmit2() {
      request({
        url: '/roles/' + this.current.uuid,
        method: 'patch',
        data: {
          type: 'update',
          attributes: this.form
        }
      }).then(res => {
        this.$message.success('更新成功')
        this.getList()
        this.dialogVisible = false
      })
    },
    getList () {
      request({
        url: '/roles',
        params: {
          per_page: this.per_page,
          page: this.page
        }
      }).then(res => {
        this.list = res.data.list
        this.total = res.data.item_total
      })
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-form-item {
  margin-bottom: 20px!important;
}
.check-box {
  line-height: 30px;
}
.table {
  border: 1px solid #ebeef5;
  border-bottom: none;
  margin-top: 10px;
}
.pager {
  margin: 15px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/RoleManage.vue